export const CLAIM_LOADING = 'CLAIM_LOADING';
export const ALL_CLAIMS = 'ALL_CLAIMS';
export const CLAIMED_POINTS = 'CLAIMED_POINTS';
export const UPDATE_CLAIM = 'UPDATE_CLAIM';
export const CLAIM_ERROR = 'CLAIM_ERROR';
export const CLAIM_RESET = 'CLAIM_RESET';
export const CLAIM_SUCCESS = 'CLAIM_SUCCESS';
